import { render, staticRenderFns } from "./PrimkaPrintManualTable.vue?vue&type=template&id=2b4f766f&scoped=true&"
import script from "./PrimkaPrintManualTable.vue?vue&type=script&lang=js&"
export * from "./PrimkaPrintManualTable.vue?vue&type=script&lang=js&"
import style0 from "./PrimkaPrintManualTable.vue?vue&type=style&index=0&id=2b4f766f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4f766f",
  null
  
)

export default component.exports